import React from 'react';
import { Container, Cursor, UserName } from './style';
import { Group, Text, Image } from 'react-konva';
import CursorIcon from 'styles/icons/cursor.svg';
import { Position } from 'types';
import { User } from 'graphql/types';

export interface CollaboratingCursorProps {
  cursorPosition: Position;
  user: User;
  color: string;
}

const defaultProps = {};

const cursorImage = new window.Image();
cursorImage.src = CursorIcon;

function CollaboratingCursor(props: CollaboratingCursorProps) {
  const imageRef = React.useRef(null);
  const fill = '#' + props.color;

  cursorImage.style.color = fill;
  cursorImage.style.fill = fill;

  React.useEffect(() => {}, []);

  return (
    <>
      <Image ref={imageRef} image={cursorImage} {...props.cursorPosition} />
      <Text
        {...props.cursorPosition}
        /*        fill={fill}*/
        text={props.user.email}
        offsetY={-30}
        offsetX={props.user.email.length * 2}
      />
    </>
  );
}

CollaboratingCursor.defaultProps = defaultProps;

export default CollaboratingCursor;
